<template>
  <div class="main-panel w-100">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'PublicDataLayout',
};
</script>

<style scoped></style>
